module.exports = __webpack_public_path__ + "img/dancer.4ecf2b9d.svg";